module.exports = __webpack_public_path__ + "img/doc_4.50907461.png";